'use client'

import { Button as ButtonOG, styled } from 'tamagui'

export const Button = styled(ButtonOG, {
  name: 'CommonButton',
  theme: 'dark',
	themeInverse: true
})
